<template functional>
  <img
    v-if="props.name"
    :src="$options.methods.getAsset(props.name, props.variant)"
    :class="$options.methods.classes(props.name, data)"
  >
</template>

<script>
const variantHexMap = {
  'mastery': '00dbfb',
  'white': 'ffffff',
  'content-secondary': '555555',
};

export default {
  props: {
    name: {
      type: String,
    },
    variant: {
      type: String,
      default: '',
    },
  },
  methods: {
    classes(name, data) {
      const defaultClasses = [`icon-${name}`];
      if (data.staticClass) {
        defaultClasses.push(data.staticClass);
      }
      if (data.class) {
        Object.keys(data.class).forEach(cls => {
          if (data.class[cls]) {
            defaultClasses.push(cls);
          }
        });
      }
      return defaultClasses.join(' ');
    },
    getAsset(name, variant) {
      if (variant) {
        const variantHex = variantHexMap[variant] || variant;
        return require(`../../assets/icons/${name}-${variantHex}.svg`);
      }
      return require(`../../assets/icons/${name}.svg`);
    },
  },
};
</script>
